import { useState } from "react";

export type ToastVariant = "success" | "error";

interface ToastState {
  message: string;
  variant: ToastVariant;
}

export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);

  function showToast(message: string, variant: ToastVariant) {
    const next = { message, variant };
    setToast(next);
    setTimeout(
      () => setToast((current) => (current === next ? null : current)),
      3000,
    );
  }

  return { toast, showToast };
}

export function Toast({ toast }: { toast: ToastState | null }) {
  if (!toast) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 rounded-lg px-4 py-2.5 text-sm shadow-2xl ${
        toast.variant === "success"
          ? "bg-success text-background"
          : "bg-danger text-background"
      }`}
    >
      {toast.message}
    </div>
  );
}
